import React, { Fragment, useEffect, useMemo, useState } from 'react'
import Button from '@material-ui/core/Button'
import { IconButton, Switch } from '@material-ui/core'
import moment from 'moment'
import Fade from '@material-ui/core/Fade'
import CircularProgress from '@material-ui/core/CircularProgress'
import useTranslation from '../../../Hooks/useTranslation'
import { makeStyles } from '@material-ui/core/styles'
import DmsService from '../../../Services/DMS/dms-api.service'
import AlertToastr from '../../../utils/alert'
import SelectJobModal from '../../../Components/modals/SelectJobModal/SelectJobModal'
import NewUnitPasswordModal from '../../../Components/modals/new-unit-password-modal/new-unit-password-modal.component'
import DeleteItemModal from '../../../Components/modals/delete-item-modal/delete-item-modal.component'
import { useUsersSettings } from '../UsersSettingsContext'
import { useQueryClient } from 'react-query'
import { useBoxes } from 'Contexts/BoxContext'
import TablePagination from '../../PredictiveMaintenance/Equipment/TablePagination'

const arrowDownClassName = 'hasArrow'
const arrowUpClassName = 'hasArrow up'

const RemoveIcon = () => <div className='removeIcon' />
const CopyIcon = () => <div className='copyIcon' />
const IcoPlusWhite = () => <div className='plusIcon' />

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
}))

const OneJobPasswords = () => {

    const {
        currentUser,
        currentCompany,
        companyDetails,
        setCompanyDetails,
        oneJobPasswords,
        oneJobPasswordFilterType,
        setOneJobPasswordFilterType,
        pagination,
        oneJobPasswordsRequest,
        allOneJobPasswordsRequest,
        onNextPage,
        onPrevPage,
        handleRowCount,
        sortColumn,
        sortDirection,
        handleSort
    } = useUsersSettings()
    const queryClient = useQueryClient()
    const translation = useTranslation();
    const classes = useStyles()
    const [newOneJobPasswordModalIsOpen, onNewOneJobPasswordModalIsOpenChange] = useState(false)
    const [removeOneJobPasswordModalIsOpen, onRemoveOneJobPasswordModalIsOpen] = useState(false)
    const [newOneUnitPasswordModalIsOpen, onNewOneUnitPasswordModalIsOpenChange] = useState(false)
    const [licensesNames, setLicensesNames] = useState(null);
    const [jobs, setJobs] = useState([])
    const [oneJobPasswordData, setOneJobPasswordData] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const isSuperUser = useMemo(() => (currentUser.isSuperuser()), [currentUser])
    const { unitsRequest } = useBoxes()
    const companyId = currentCompany ? currentCompany.id : currentUser?.companyId

    const toggleFilterType = (e) => {
        const newType = oneJobPasswordFilterType === 'job' ? 'unit' : 'job'
        setOneJobPasswordFilterType(newType)
    };

    useEffect(() => {
        if (oneJobPasswordsRequest?.isLoading) {
            setIsLoading(true)
        } else {
            setIsLoading(false)
        }
    }, [oneJobPasswordsRequest?.isLoading])

    // useEffect(() => {
    //     const fetchOneJobPasswords = async () => {
    //         try {
    //             let response
    //             if (isSuperUser) {
    //                 if (!currentCompany)
    //                     return
    //                 response = await DmsService.getOneJobPasswordsByCompanyId(currentCompany.id)
    //             } else {
    //                 response = await DmsService.getOneJobPasswords()
    //             }
    //             if (response.status === noContentStatus) {
    //                 setOneJobPasswords([])
    //             }
    //             if (response.status === successStatus) {
    //                 response.data.map((oneJobPassword) => {
    //                     const passwordJob = jobs.find(job => job.id === oneJobPassword.jobId)
    //                     if (passwordJob) {
    //                         oneJobPassword.jobName = passwordJob.name
    //                         oneJobPassword.jobStartTime = passwordJob.startTime
    //                     }
    //                     return oneJobPassword
    //                 })
    //                 setOneJobPasswords(response.data)
    //             }
    //         } catch (error) {
    //             if (error && error.response && error.response.data && error.response.data.Message)
    //                 AlertToastr.showErrorAlert(error.response.data.Message)
    //         }
    //     }
    //     if (updateOneJobPassword && jobs.length) {
    //         fetchOneJobPasswords().then()
    //         setUpdateOneJobPassword(false)
    //     }
    //
    // }, [jobs, updateOneJobPassword, currentCompany, isSuperUser])

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                let response
                const tabType = oneJobPasswordFilterType === 'unit' ? 'Units' : undefined
                if (isSuperUser) {
                    if (!currentCompany)
                        return
                    response = await DmsService.getCompanyJobsShort(currentCompany.id, tabType)
                } else {
                    response = await DmsService.getJobsShort(tabType)
                }
                setJobs(response)
            } catch (error) {
                if (error && error.response && error.response.data && error.response.data.Message)
                    AlertToastr.showErrorAlert(error.response.data.Message)
            }
        }
        fetchJobs().then()
    }, [currentCompany, isSuperUser, oneJobPasswordFilterType])

    const fetchLicenseIds = async () => {
        try {
            let response;
            if (isSuperUser)
                response = await DmsService.getLicenseIdsByCompanyId(currentCompany.id);
            else
                response = await DmsService.getLicenseIds();
                setLicensesNames(response.data);
        } catch (error) {
            if (error && error.response && error.response.data && error.response.data.Message)
                AlertToastr.showErrorAlert(error.response.data.Message);
        }
    };

    useEffect(() => {
        fetchLicenseIds();
    }, [newOneUnitPasswordModalIsOpen, currentCompany, isSuperUser]); // eslint-disable-line react-hooks/exhaustive-deps

    const processedOneJobPasswords = useMemo(() => {
        const units = Array.isArray(unitsRequest?.data) ? unitsRequest.data : []

        return oneJobPasswords.map((oneJobPassword) => {
            if (oneJobPasswordFilterType === 'unit') {
                const unitUId = oneJobPassword.uId || oneJobPassword.unitId || oneJobPassword.unitUId

                if (unitUId && units.length > 0) {
                    const passwordUnit = units.find(unit => unit.uId === unitUId)
                    if (passwordUnit) {
                        return {
                            ...oneJobPassword,
                            unitName: passwordUnit.nameLocalized || passwordUnit.name,
                            unitStartTime: passwordUnit.latestStartTime
                        }
                    }
                }
                return {
                    ...oneJobPassword,
                    unitName: ''
                }
            } else {
                const passwordJob = Array.isArray(jobs) && jobs.length ? jobs.find(job => job.id === oneJobPassword.jobId) : null
                if (passwordJob) {
                    return {
                        ...oneJobPassword,
                        jobName: passwordJob.name,
                        jobStartTime: passwordJob.startTime
                    }
                }
                return oneJobPassword
            }
        })
    }, [oneJobPasswords, jobs, unitsRequest, oneJobPasswordFilterType])

    const passwordCounts = useMemo(() => {
        const allPasswords = Array.isArray(allOneJobPasswordsRequest?.data?.data) ? allOneJobPasswordsRequest.data.data : []
        
        const jobsCount = allPasswords.filter(password => {
            const hasUnitId = password.unitId || password.unitUId || password.uId
            return password.jobId && !hasUnitId
        }).length

        const unitsCount = allPasswords.filter(password => {
            return password.unitId || password.unitUId || password.uId
        }).length

        return { jobsCount, unitsCount }
    }, [allOneJobPasswordsRequest?.data?.data])

    const getClassNamesForOneJobPassword = (columnName) => {
        if (sortColumn !== columnName) {
            return
        }
        return sortDirection === 'Asc' ? arrowDownClassName : arrowUpClassName
    }

    const getAllowedJobsNames = (allowedJobs) => {
        if (!allowedJobs || allowedJobs.key === 'all') {
            return 'All'
        }
        if (allowedJobs.key === 'custom' && Array.isArray(allowedJobs.value) && allowedJobs.value.length > 0) {
            const jobNames = allowedJobs.value
                .map(jobId => {
                    const job = Array.isArray(jobs) ? jobs.find(j => j.id === jobId) : null
                    return job ? job.name : null
                })
                .filter(name => name !== null)
            return jobNames.length > 0 ? jobNames : []
        }
        return 'All'
    }

    const getAllowedLicensesNames = (allowedLicenses) => {
        if (!allowedLicenses || allowedLicenses.key === 'all') {
            return 'All'
        }
        if (allowedLicenses.key === 'custom' && Array.isArray(allowedLicenses.value) && allowedLicenses.value.length > 0) {
            const licenseNames = allowedLicenses.value
                .map(licenseId => {
                    const license = Array.isArray(licensesNames) ? licensesNames.find(l => l.licenseId === licenseId) : null
                    return license ? license.name : null
                })
                .filter(name => name !== null)
            return licenseNames.length > 0 ? licenseNames : []
        }
        return 'All'
    }

    const mapColumnToBackendColumn = (frontendColumn) => {
        const columnMap = {
            'jobName': 'Id',
            'unitUId': 'UnitUId',
            'password': 'Password',
            'status': 'IsEnabled',
            'csv_export': 'CanDownloadDataFile',
            'activeSessions': 'ActiveSessions',
            'validTo': 'ValidTo'
        }
        return columnMap[frontendColumn] || frontendColumn
    }

    const onAllowOneJobPasswordValueChanged = (updatedCompany) => {
        DmsService.updateCompany(updatedCompany).then()
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.Message)
                    AlertToastr.showErrorAlert(error.response.data.Message)
            })
    }

    const onOneJobPasswordEnabledChanged = (oneJobPassword) => {
        oneJobPassword.isEnabled = !oneJobPassword.isEnabled
        DmsService.updateIsEnabledOneJobPassword(oneJobPassword.id, !oneJobPassword.isEnabled).then(res => {
            queryClient.invalidateQueries('settingsOneJobPasswords').then()
            // setUpdateOneJobPassword(true)
        })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.Message)
                    AlertToastr.showErrorAlert(error.response.data.Message)
            })
    }

    const onOneJobPasswordCsvExportChanged = oneJobPassword => {
        DmsService.updateOneJobPassword({
            ...oneJobPassword,
            canDownloadDataFile: !oneJobPassword.canDownloadDataFile
        }).then(res => {
            queryClient.invalidateQueries('settingsOneJobPasswords').then()
        })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.Message)
                    AlertToastr.showErrorAlert(error.response.data.Message)
            })
    }

    const copyLinkToClipboard = async (id) => {
        try {
            let response = await DmsService.getOneJobPasswordLink(id)
            navigator.clipboard.writeText(response.data);
            AlertToastr.showAlert(translation.notificationsLinkCopied)
        } catch (error) {
            if (error && error.response && error.response.data && error.response.data.Message)
                AlertToastr.showErrorAlert(error.response.data.Message)
        }

    }

    const onCreateOneJobPassword = (jobId) => {
        onNewOneJobPasswordModalIsOpenChange(false)
        DmsService.createOneJobPassword(jobId, companyId).then(res => {
            queryClient.invalidateQueries('settingsOneJobPasswords').then()
            queryClient.invalidateQueries('settingsAllOneJobPasswords').then()
        })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message)
            })
    }

    const onCreateOneUnitPassword = (unitPasswordInfo) => {
        if (!unitPasswordInfo) {
            onNewOneUnitPasswordModalIsOpenChange(false)
            return
        }
        const uId = unitPasswordInfo.unitUId
        DmsService.createOneUnitPassword(uId, companyId, unitPasswordInfo).then(res => {
            onNewOneUnitPasswordModalIsOpenChange(false)
            queryClient.invalidateQueries('settingsOneJobPasswords').then()
            queryClient.invalidateQueries('settingsAllOneJobPasswords').then()
        })
            .catch((error) => {
                if (error && error.response && error.response.data) {
                    const errData = error.response.data;
                    if (Array.isArray(errData.errors) && errData.errors.length > 0) {
                        errData.errors.forEach((e) => {
                            AlertToastr.showErrorAlert(e.ErrorMessage);
                        });
                    } else if (typeof errData.Message === "string") {
                        AlertToastr.showErrorAlert(errData.Message);
                    } else if (typeof errData.message === "string") {
                        AlertToastr.showErrorAlert(errData.message);
                    } else {
                        AlertToastr.showErrorAlert("An unexpected error occurred.");
                    }
                } else {
                    AlertToastr.showErrorAlert("An unexpected error occurred.");
                }
            })
    }

    const onDeleteOneJobPassword = () => {
        DmsService.deleteOneJobPassword(oneJobPasswordData.id).then(res => {
                queryClient.invalidateQueries('settingsOneJobPasswords').then()
                queryClient.invalidateQueries('settingsAllOneJobPasswords').then()
            }

        )
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.Message)
                    AlertToastr.showErrorAlert(error.response.data.Message)
            })
    }

    return (
        <Fragment>
            <div className="pageBtnSection pt0 oneJobPassBlock">
                <div className="part" style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '20px', minWidth: '200px' }} className={oneJobPasswordFilterType === 'job' ? 'optionsSwitch' : 'optionsSwitch in'}>
                        <div className="option" onClick={toggleFilterType}>Jobs ({passwordCounts.jobsCount})</div>
                        <div className="option" onClick={toggleFilterType} id="settingsOneJobPasswordsUnitsFilter">Units ({passwordCounts.unitsCount})</div>
                    </div>
                    <Button className="addItem"
                            variant="contained"
                            color='primary'
                            startIcon={<IcoPlusWhite />}
                            id={oneJobPasswordFilterType === 'job' ? 'settingsNewJobPasswordBtn' : 'settingsNewUnitPasswordBtn'}
                            onClick={() => oneJobPasswordFilterType === 'job' ? onNewOneJobPasswordModalIsOpenChange(true) : onNewOneUnitPasswordModalIsOpenChange(true)}
                    >
                        {oneJobPasswordFilterType === 'job' ? translation.settingsTablesNewJobPasswordLabel : translation.settingsTablesNewUnitPasswordLabel}
                    </Button>
                </div>
                <div className="part end oneJobPassBlock">
                    <div className='reverseSwitchHolder'>
                        {
                            companyDetails && (
                                <Switch checked={companyDetails?.allowOneJobPassword}
                                        onChange={(e) => {
                                            setCompanyDetails(company => {
                                                const updatedCompany = { ...company, allowOneJobPassword: !company.allowOneJobPassword }
                                                onAllowOneJobPasswordValueChanged(updatedCompany)
                                                return updatedCompany
                                            })

                                        }}
                                        color="primary"
                                />
                            )
                        }
                        <div className='reverseSwitcherLabel'>{translation.settingsTablesAllowOneJobPasswordLabel}</div>
                    </div>
                </div>
            </div>
            <div className="pageCard noPadding">
                <div className="tableHolder">
                    <table>
                        <thead>
                        <tr className='headingRow'>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('jobName'))}
                                className={getClassNamesForOneJobPassword(mapColumnToBackendColumn('jobName'))}>
                                {oneJobPasswordFilterType === 'job' ? translation.settingsTablesJobNameHeader : translation.settingsTablesUnitNameHeader}
                            </th>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('unitUId'))}
                                className={getClassNamesForOneJobPassword(mapColumnToBackendColumn('unitUId'))} style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                Unit ID
                            </th>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('password'))}
                                className={getClassNamesForOneJobPassword(mapColumnToBackendColumn('password'))}>
                                {translation.settingsTablesPasswordHeader}
                            </th>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('status'))}
                                className={`text-center ${getClassNamesForOneJobPassword(mapColumnToBackendColumn('status'))}`}>
                                {translation.settingsTablesStatusHeader}
                            </th>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('csv_export'))}
                                className={`text-center ${getClassNamesForOneJobPassword(mapColumnToBackendColumn('csv_export'))}`}>
                                {translation.settingsTablesCsvExportHeader}
                            </th>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('activeSessions'))}
                                className={`text-center ${getClassNamesForOneJobPassword(mapColumnToBackendColumn('activeSessions'))}`}>
                                {translation.settingsTablesSessionsHeader}
                            </th>
                            <th onClick={() => handleSort(mapColumnToBackendColumn('validTo'))}
                                style={{ display: oneJobPasswordFilterType === 'job' ? 'table-cell' : 'none' }}
                                className={getClassNamesForOneJobPassword(mapColumnToBackendColumn('validTo'))}>
                                {translation.settingsTablesValidToHeader}
                            </th>
                            <th 
                                 style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                Valid To
                            </th>
                            <th 
                                 style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                Data Access Range
                            </th>
                            <th 
                                 style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                Allowed Jobs
                            </th>
                            <th 
                                 style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                Allowed Licenses
                            </th>
                            <th />
                        </tr>
                        </thead>
                        <tbody>
                        {
                            processedOneJobPasswords && Array.isArray(processedOneJobPasswords) && processedOneJobPasswords.map(oneJobPassword => {
                                return (
                                    <tr key={oneJobPassword.id}>
                                        <td>
                                            {oneJobPasswordFilterType === 'unit' ? oneJobPassword.unitName : oneJobPassword.jobName}
                                        </td>
                                        <td style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                            {oneJobPassword.unitUId || oneJobPassword.unitId}
                                        </td>
                                        <td>
                                            {oneJobPassword.password}
                                        </td>
                                        <td className='text-center switchCell' onClick={() => onOneJobPasswordEnabledChanged(oneJobPassword)}>
                                            <Switch checked={oneJobPassword.isEnabled}
                                                    color="primary" />
                                        </td>
                                        <td className='text-center switchCell' onClick={() => onOneJobPasswordCsvExportChanged(oneJobPassword)}>
                                            <Switch checked={oneJobPassword.canDownloadDataFile}
                                                    color="primary" />
                                        </td>
                                        <td className='text-center'>{+oneJobPassword.activeSessions || '-'}</td>
                                        <td style={{ display: oneJobPasswordFilterType === 'job' ? 'table-cell' : 'none' }}>{oneJobPassword.validTo ? moment.utc(oneJobPassword.validTo).local().format('DD.MM.YYYY HH:mm') : ''}</td>
                                        <td style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                        {oneJobPassword.validTo ? moment.utc(oneJobPassword.validTo).local().format('DD.MM.YYYY HH:mm') : ''}
                                        </td>
                                        <td style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                            {oneJobPassword.dataAccessRange?.key === 'custom' && oneJobPassword.dataAccessRange?.value?.from && oneJobPassword.dataAccessRange?.value?.to
                                                ? `${moment.utc(oneJobPassword.dataAccessRange.value.from).local().format('DD.MM.YYYY HH:mm')} - ${moment.utc(oneJobPassword.dataAccessRange.value.to).local().format('DD.MM.YYYY HH:mm')}`
                                                : oneJobPassword.dataAccessRange?.key === 'all' ? 'All' : ''}
                                        </td>
                                        <td style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                            {(() => {
                                                const jobsList = getAllowedJobsNames(oneJobPassword.allowedJobs);
                                                if (jobsList === 'All') {
                                                    return 'All';
                                                }
                                                if (Array.isArray(jobsList) && jobsList.length > 0) {
                                                    return jobsList.map((jobName, index) => (
                                                        <div key={index}>{jobName}</div>
                                                    ));
                                                }
                                                return '';
                                            })()}
                                        </td>
                                        <td style={{ display: oneJobPasswordFilterType === 'job' ? 'none' : 'table-cell' }}>
                                            {(() => {
                                                const licensesList = getAllowedLicensesNames(oneJobPassword.allowedLicenses);
                                                if (licensesList === 'All') {
                                                    return 'All';
                                                }
                                                if (Array.isArray(licensesList) && licensesList.length > 0) {
                                                    return licensesList.map((licenseName, index) => (
                                                        <div key={index}>{licenseName}</div>
                                                    ));
                                                }
                                                return '';
                                            })()}
                                        </td>
                                        <td className={'actionTableCell'}>
                                            <IconButton size={'small'} className={'deleteTableItemBtn'}
                                                        onClick={(e) => {
                                                            copyLinkToClipboard(oneJobPassword.id)
                                                        }}>
                                                <CopyIcon />
                                            </IconButton>
                                            <IconButton size={'small'} className={'deleteTableItemBtn'}
                                                        id={oneJobPasswordFilterType === 'job' ? 'settingsRemoveOneJobPasswordBtn' : 'settingsRemoveOneUnitPasswordBtn'}
                                                        onClick={(e) => {
                                                            setOneJobPasswordData(oneJobPassword)
                                                            onRemoveOneJobPasswordModalIsOpen(true)
                                                        }}>
                                                <RemoveIcon />
                                            </IconButton>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                    <div className={classes.root}>
                        <Fade
                            in={isLoading}
                            unmountOnExit>
                            <CircularProgress />
                        </Fade>
                    </div>
                </div>
            </div>
            {pagination && (oneJobPasswords.length > 0 || pagination.itemsTotalCount > 0) && (
                <TablePagination
                    pagination={pagination}
                    onPrevPage={onPrevPage}
                    onNextPage={onNextPage}
                    handleRowCount={handleRowCount}
                    loading={oneJobPasswordsRequest?.isLoading}
                />
            )}
            <SelectJobModal jobs={jobs}
                            title={'Select Job'}
                            isOpen={newOneJobPasswordModalIsOpen}
                            onCancel={() => { onNewOneJobPasswordModalIsOpenChange(false) }}
                            onSave={onCreateOneJobPassword}
                            setCurrentJobUnits={null}
                            type={'oneJobPassword'} />
            <DeleteItemModal isOpen={removeOneJobPasswordModalIsOpen}
                             isOpenManager={onRemoveOneJobPasswordModalIsOpen}
                             message={translation.removeOneJobPasswordModalMessageLabel}
                             onDeleteModalClose={onDeleteOneJobPassword} />
            <NewUnitPasswordModal 
                            isOpen={newOneUnitPasswordModalIsOpen}
                            isOpenChangeHandler={onNewOneUnitPasswordModalIsOpenChange}
                            onRequestClose={onCreateOneUnitPassword}
                            companyId={companyId}
                            jobs={jobs}
                            licensesNames={licensesNames} />
        </Fragment>
    )
}

export default OneJobPasswords
